import type { ComponentType, ReactNode } from "react";
import { AuthKitProvider } from "@workos-inc/authkit-react";

interface WorkOSAuthProviderProps {
  children: ReactNode;
}

const UnsafeAuthKitProvider = AuthKitProvider as unknown as ComponentType<{
  children: ReactNode;
  clientId: string;
  redirectUri: string;
}>;

export function WorkOSAuthProvider({ children }: WorkOSAuthProviderProps) {
  const clientId = import.meta.env?.VITE_WORKOS_CLIENT_ID as string | undefined;
  const redirectUri =
    (import.meta.env?.VITE_WORKOS_REDIRECT_URI as string | undefined) ??
    `${window.location.origin}/auth/callback`;

  if (!clientId) {
    throw new Error("VITE_WORKOS_CLIENT_ID is required");
  }

  return (
    <UnsafeAuthKitProvider clientId={clientId} redirectUri={redirectUri}>
      {children}
    </UnsafeAuthKitProvider>
  );
}
